import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  groups: [],
  currentGroup: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  filters: {
    search: '',
    course: 'all',
    status: 'all'
  }
}

const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setGroups: (state, action) => {
      state.groups = action.payload
    },
    setCurrentGroup: (state, action) => {
      state.currentGroup = action.payload
    },
    addGroup: (state, action) => {
      state.groups.push(action.payload)
    },
    updateGroup: (state, action) => {
      const index = state.groups.findIndex(group => group.id === action.payload.id)
      if (index !== -1) {
        state.groups[index] = action.payload
      }
    },
    removeGroup: (state, action) => {
      state.groups = state.groups.filter(group => group.id !== action.payload)
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setLoading,
  setError,
  setGroups,
  setCurrentGroup,
  addGroup,
  updateGroup,
  removeGroup,
  setPagination,
  setFilters,
  clearError
} = groupsSlice.actions

export default groupsSlice.reducer